import styled from 'styled-components'

export const StatusBadge = styled.span`
    padding: 4px 8px;
    border-radius: 12px;
    color: #fff;
    font-size: 12px;
    background-color: ${props => {
        switch (!!props.status) {
            case true:
                return 'green';
            case false:
                return 'red';
            default:
                return 'gray';
        }
    }};
`